var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gmap-map',{staticStyle:{"width":"100%","height":"400px"},attrs:{"options":{ disableDoubleClickZoom: true, draggable: false, maxZoom: 13 },"center":_vm.center,"zoom":13,"disableDoubleClickZoom":true}},[_c('gmap-marker',{attrs:{"position":_vm.marker.position,"icon":{ url: require('@/assets/marker.png')}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }